import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from 'date-fns';

type DateRange = {
  firstDay: Date;
  lastDay: Date;
};

export const SessionStorageService = {
  setDatePickerLastDateRange(firstDay: Date, lastDay: Date, datePickerType: string): void {
    const firstDayPlain = {
      year: firstDay.getFullYear(),
      month: firstDay.getMonth(),
      day: firstDay.getDate(),
    };
    const lastDayPlain = {
      year: lastDay.getFullYear(),
      month: lastDay.getMonth(),
      day: lastDay.getDate(),
    };

    sessionStorage.setItem(
      datePickerType,
      JSON.stringify({ firstDay: firstDayPlain, lastDay: lastDayPlain })
    );
  },

  getDatePickerLastDateRangeOrDefault(datePickerType: string): DateRange {
    const isWeek = datePickerType === SessionStorageItems.weekPickerLastDateRange;

    const defaultRange: DateRange = {
      firstDay: isWeek ? startOfWeek(new Date(), { weekStartsOn: 1 }) : startOfMonth(new Date()),
      lastDay: isWeek ? endOfWeek(new Date(), { weekStartsOn: 1 }) : endOfMonth(new Date()),
    };

    defaultRange.firstDay.setHours(0, 0, 0, 0);
    defaultRange.lastDay.setHours(23, 59, 59, 999);

    const stored = sessionStorage.getItem(datePickerType);
    if (stored) {
      const parsed = JSON.parse(stored);

      defaultRange.firstDay = new Date(
        parsed.firstDay.year,
        parsed.firstDay.month,
        parsed.firstDay.day
      );
      defaultRange.firstDay.setHours(0, 0, 0, 0);

      defaultRange.lastDay = new Date(
        parsed.lastDay.year,
        parsed.lastDay.month,
        parsed.lastDay.day,
        23,
        59,
        59,
        999
      );
    }
    return defaultRange;
  },
};

export const SessionStorageItems = {
  weekPickerLastDateRange: 'weekPickerLastDateRange',
  monthPickerLastDateRange: 'monthPickerLastDateRange',
};
